const getters = {
    bookingCart: state => state.bookingCart,
    bookingStatus: state => state.bookingStatus,
    bookingErrors: state => state.bookingErrors,
    paymentStatus: state => state.paymentStatus,
    paymentErrors: state => state.paymentErrors,
    mybookings: state => state.mybookings,
};

export default getters;
